import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>Hello CSCI E-39!</p>
        <p>
          My name is Karen Dolan
        </p>
      </header>
    </div>
  );
}

export default App;
